module.exports = __webpack_public_path__ + "static/images/lottery.448d54b.png";